// Avatar.tsx
import React from 'react';
import { Avatar as MuiAvatar } from '@mui/material';
import { styled } from '@mui/material/styles';

interface AvatarProps {
  src?: string;
  alt?: string;
  name: string;
}

const StyledAvatar = styled(MuiAvatar)(({ theme }) => ({
  width: 40,
  height: 40,
  fontSize: '1.25rem',
  fontWeight: 500,
  backgroundColor: theme.colors.lavenderCard,
  color: '#ffffff',
}));

const Avatar: React.FC<AvatarProps> = ({ src, alt, name }) => {
  const initial = name.charAt(0).toUpperCase();
  return (
    <StyledAvatar src={src} alt={alt || name}>
      {!src && initial}
    </StyledAvatar>
  );
};

export default Avatar;
